import { EquatorialCoord } from '@hscmap/angle';
import { Vue, Component, Prop } from "vue-property-decorator";
import { BookmarkModule, foldersIn, newBookmark, newBookmarkFolder } from '@/modules/BookMarkModule';
import { store } from '@/store';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: BookmarkModule

  name = ''
  folder = this.module.root

  add() {
    const b = newBookmark(this.name, store.currentFrame.view)
    this.folder.children.push(b)
    this.close()
  }

  get folderPaths() {
    return foldersIn(this.module.root)
  }

  newFolder() {
    const path = this.folderPaths.filter((p) => p.folder === this.folder)[0].path
    const name = prompt(`Folder name ?\n> ${path}`)
    if (name) {
      const newFolder = newBookmarkFolder(name)
      this.folder.children.push(newFolder)
      this.folder = newFolder
    }
  }

  close() {
    this.module.showAddBookmark = false
  }

  mounted() {
    this.$watch(() => this.module.showAddBookmark, (isOpen) => {
      if (isOpen) {
        const { a, d, fovy, roll } = store.currentFrame.view
        const { a: a60, d: d60 } = EquatorialCoord.fromRad(a, d).toString()
        this.name = `${a60} ${d60}`
        this.$nextTick(() => (this.$refs.name as HTMLInputElement).focus())
      }
    })
  }
}
